import { makeStyles } from "@material-ui/core/styles";

const buttonStyles = makeStyles((theme) => ({
  isDiv: {},
  root: {
    width: "243px",
    height: "50px",
    borderRadius: "60px",
    border: `1px solid ${theme.palette.primary.body}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& .MuiButton-label": {
      fontSize: "15px",
      color: theme.palette.primary.btnText,
      fontWeight: 400
    },
    "& $isDiv": {
      fontSize: "16px",
      color: theme.palette.primary.btnText,
      fontWeight: 600
    }
  },
  gradientBg: {
    background: "#3b51fa !important",
    border: "none",
    "& .MuiButton-label": {
      fontSize: "13px",
      color: "#fff !important",
      fontWeight: 600
    },
  },
  circularStyle: {
    color: theme.palette.primary.white,
  },
  ctnDisabled: {
    opacity: 0.7
  },
}));

export default buttonStyles;
